"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _setAttendeeMuteStatus = _interopRequireDefault(require("../../../actions/attendee/setAttendeeMuteStatus"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function attendeeMicStatusChanged(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var attendeeId = _ref2.attendeeId,
    isMuted = _ref2.isMuted;
  dispatch((0, _setAttendeeMuteStatus["default"])(attendeeId, isMuted));
}
var _default = exports["default"] = attendeeMicStatusChanged;